import { isEmpty } from './helpers/is-empty';
import { jsonataEval } from '../../jsonata/functions/jsonata-eval';
import { AsyncValidatorFunction } from '../types/validator-function.type';

export const jsonata: AsyncValidatorFunction = async (
  _value: any,
  args: { expression?: string; message?: string },
  formValue: any
) => {
  if (isEmpty(args) || isEmpty(args.expression)) {
    return null;
  }

  return (await jsonataEval(args.expression, formValue)) ? null : { jsonata: args };
};
